/**
 * THE BROWSER TAB, WHICH NEVER CHANGED.
 *
 * `document.title` was assigned nowhere in this product: every screen, on every
 * route, was "Lobbero" — the value baked into index.html. That costs three
 * different people three different things:
 *
 *   · a concierge with the desk in one tab and the dashboard in another cannot
 *     tell them apart without switching to each;
 *   · a screen-reader user is announced the same page name on every navigation,
 *     which is one of the few signals a single-page app gives that navigation
 *     happened at all;
 *   · browser history and bookmarks are a wall of identical entries.
 *
 * Title LAST, product FIRST is deliberate — "Parcels · Lobbero". Tabs truncate
 * from the right, and the half that distinguishes this tab from the next one is
 * the screen name, so it goes where it survives.
 *
 * Restores the previous title on unmount so a screen that is torn down without
 * a navigation (a modal route, a fast redirect) cannot leave its name behind.
 */
import { useEffect } from 'react';

const PRODUCT = 'Lobbero';

export const useDocumentTitle = (title?: string | null): void => {
  useEffect(() => {
    const previous = document.title;

    document.title = title ? `${title} · ${PRODUCT}` : PRODUCT;

    return () => {
      document.title = previous;
    };
  }, [title]);
};
